import React, {useState} from "react";
import {AuthContext} from "./AuthContext";
import {User} from "../model/User";

const AuthProvider =  ({ children } : {children: JSX.Element }) => {

    const [user, setUser] = useState<User | null>(() => {
        // Carrega o usuário do localStorage
        const savedUser = sessionStorage.getItem('*app-agrolend-sai-user');
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const signIn =async (username: string, password: string) => {

        if(username === 'admin' && password === 'admin') {
            const user = new User('1', 'admin', 'admin', 'admin@agorlend.com.br', '11997873166', ['ADMIN'], 'admin');
            sessionStorage.setItem('*app-agrolend-sai-user', JSON.stringify(user));
            setUser(user);
            return true
        }

        return false;

    }

    const signOut = async () => {
        setUser(null);
        sessionStorage.removeItem('*app-agrolend-sai-user');
    };


    return (
        <AuthContext.Provider value={{user, signIn, signOut }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;